<template>
    <div id="high-performing-managers" class="page-container">
      <div class="page-content">
        <div class="flex-mid">
          <div class="container">
            <div class="header">
              <div class="logo">
                <img src="https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Freport_monthly%2Fic_rel_manager.png?alt=media&token=f88f9f2e-31cc-4b29-922d-b54e040fdee1" alt="Happily Managers" style="width: 60px; height: auto;">
              </div>
              <div class="header-text">
                <h1>Happily Leadership</h1>
                <p>Relationship with Manager Nudge</p>
              </div>
            </div>
            <loadingEven v-if="loading" style="text-align: center; margin-top: 20px;"/>
            <div v-else>    
                <h1 class="page-title">{{ com_name }}'s {{ sortedManagers.length }} High Performing Managers</h1>
                <p class="subtitle">Managers who led the way by consistently replying to team feedback, giving performance boosts, and leading engaged teams.</p>
    
                <div class="criteria">
                <div class="criteria-text">
                    <strong>Qualification Criteria:</strong> Reply Rate ≥ 60% • Boosters On Track ≥ 60% • DEBI ≥50
                </div>
                </div>
    
                <div class="performance-insights">
                <div class="insights-header">
                    <h2>Manager Performance Impact</h2>
                    <p>How high-performing manager effort and outcomes compare to the organization average</p>
                </div>
                
                <div class="comparison-charts">
                    <div class="chart-section">
                    <div class="chart-header">
                        <h3>Reply Rate Comparison</h3>
                        <div class="chart-legend">
                        <div class="legend-item">
                            <div class="legend-color high-performers"></div>
                            <span>High Performers ({{ replyRate.highPerformers }}%)</span>
                        </div>
                        <div class="legend-item">
                            <div class="legend-color org-average"></div>
                            <span>Org Average ({{ replyRate.orgAverage }}%)</span>
                        </div>
                        </div>
                    </div>
                    <div class="comparison-bars">
                        <div class="bar-container">
                        <div class="bar high-performers" :style="{width: replyRate.highPerformers + '%'}">
                            <span class="bar-label">{{ replyRate.highPerformers }}%</span>
                        </div>
                        </div>
                        <div class="bar-container">
                        <div class="bar org-average" :style="{width: replyRate.orgAverage + '%'}">
                            <span class="bar-label">{{ replyRate.orgAverage }}%</span>
                        </div>
                        </div>    
                    </div>
                    <div class="impact-note">
                        <strong>+{{ replyRate.compare }} percentage points</strong> higher than average
                    </div>
                    </div>
    
                    <div class="chart-section">
                    <div class="chart-header">
                        <h3>DEBI Score Comparison</h3>
                        <div class="chart-legend">
                        <div class="legend-item">
                            <div class="legend-color high-performers"></div>
                            <span>High Performers ({{ debi.highPerformers }})</span>
                        </div>
                        <div class="legend-item">
                            <div class="legend-color org-average"></div>
                            <span>Org Average ({{ debi.orgAverage }})</span>
                        </div>
                        </div>
                    </div>
                    <div class="comparison-bars">
                        <div class="bar-container">
                        <div class="bar high-performers" :style="{width: debi.highPerformers + '%'}">
                            <span class="bar-label">{{ debi.highPerformers }}</span>
                        </div>
                        </div>
                        <div class="bar-container">
                        <div class="bar org-average" :style="{width: debi.orgAverage + '%'}">
                            <span class="bar-label">{{ debi.orgAverage }}</span>
                        </div>
                        </div>
                    </div>
                    <div class="impact-note">
                        <strong>+{{ debi.compare }} points</strong> higher than average
                    </div>
                    </div>
                </div>
                </div>
    
                <div v-if="autosendgem" class="gem-callout">
                  <div class="gem-icon">
                      <img src="https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Freport_monthly%2Fic_gem_bonus.png?alt=media&token=4344f731-bd66-46a5-9923-e1b6c1c2df4b" alt="Gem Bonus" style="width: 48px; height: 48px;">
                  </div>
                  <div class="gem-content">
                      <h3>+1 GEM BONUS</h3>
                      <p>This month, <strong> {{ highPerformingManagers.length }} managers</strong> have qualified for High Performer recognition based on outstanding results. Congratulations to all who achieved this distinction.</p>
                  </div>
                </div>
    
                <div class="managers-table" :class="{ scrolled: isTableScrolled }">
                <table class="table">
                    <thead>
                    <tr>
                        <th class="sortable" data-column="manager" @click="handleSort('manager')">
                        Manager
                        </th>
                        <th class="text-center sortable" data-column="reply-rate" @click="handleSort('reply-rate')">
                        Reply Rate
                        </th>
                        <th class="text-center sortable" data-column="boosters" @click="handleSort('boosters')">
                        Boosters
                        </th>
                        <th class="text-center sortable" data-column="debi" @click="handleSort('debi')">
                        DEBI
                        </th>
                        <th class="text-center sortable sort-desc" data-column="performance-history" @click="handleSort('performance-history')">
                        Performance History
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="manager in sortedManagers" :key="manager.id">
                        <td>
                        <div class="manager-cell">

                            <div v-if="manager.profile">
                                <img :src="manager.profile" alt="Manager Profile" style="width: 40px; height: 40px; border-radius: 50%;">
                            </div>
                            <div v-else>
                                <div class="manager-avatar" :style="{ background: manager.avatarColor }">
                                    {{ manager.initials }}
                                </div>

                            </div>


                            <!-- <div class="manager-avatar" :style="{ background: manager.avatarColor }">
                            {{ manager.initials }}
                            </div> -->
                            <div class="manager-info">
                            <h3>{{ manager.name }}</h3>
                            <p>{{ manager.department }}</p>
                            </div>
                        </div>
                        </td>
                        <td class="text-center">
                        <span :class="['metric-badge', getMetricClass(manager.replyRate)]">
                            {{ manager.replyRate }}%
                        </span>
                        </td>
                        <td class="text-center">
                        <span :class="['metric-badge', getMetricClass(manager.boosters)]">
                            {{ manager.boosters }}%
                        </span>
                        </td>
                        <td class="text-center">
                        <span :class="['metric-badge', getDebiClass(manager.debi)]">
                            {{ manager.debi }}
                        </span>
                        </td>
                        <td class="text-center">
                        <div class="performance-history">
                            <div class="total-months">{{ manager.high_performing_managers?manager.high_performing_managers:0 }} months</div>
                            <div :class="['current-streak', getStreakClass(manager.high_performing_managers?manager.high_performing_managers:0)]">
                            {{ manager.high_performing_managers?manager.high_performing_managers:0 }} mo streak
                            </div>
                        </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>
           
                <div style="text-align: center; color: #666; font-size: 14px; margin-top: 40px;">
                <p>This is confidential data. Please do not share it with anyone.</p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import CryptoJS from "crypto-js";
  
  export default {

    name: 'HighPerformingManagers',
    components: {
    loadingEven: require("./even/loading").default,
    },
  
    data() {
      return {
        companyName: this.$route.params.companyName,
        isTableScrolled: false,
        com_name:'',
        currentSort: { 
          column: 'performance-history', 
          direction: 'desc' 
        },
        managers: [
          {
            id: 1,
            name: 'Robert Davis',
            initials: 'RD',
            department: 'Finance A',
            avatarColor: '#7B68EE',
            replyRate: 100,
            boosters: 84,
            debi: 81,
            totalMonths: 12,
            streakMonths: 8
          },
          {
            id: 2,
            name: 'Lisa Kumar',
            initials: 'LK',
            department: 'Sales Strategy',
            avatarColor: '#4A90E2',
            replyRate: 100,
            boosters: 78,
            debi: 72,
            totalMonths: 8,
            streakMonths: 5
          },
          {
            id: 3,
            name: 'Matthew Rodriguez',
            initials: 'MR',
            department: 'Design',
            avatarColor: '#FF9500',
            replyRate: 95,
            boosters: 67,
            debi: 58,
            totalMonths: 5,
            streakMonths: 3
          },
          {
            id: 4,
            name: 'Sarah Chen',
            initials: 'SC',
            department: 'Product Marketing',
            avatarColor: '#34C759',
            replyRate: 92,
            boosters: 75,
            debi: 69,
            totalMonths: 9,
            streakMonths: 6
          },
          {
            id: 5,
            name: 'David Johnson',
            initials: 'DJ',
            department: 'Engineering',
            avatarColor: '#FF6B9D',
            replyRate: 88,
            boosters: 82,
            debi: 76,
            totalMonths: 4,
            streakMonths: 2
          },
          {
            id: 6,
            name: 'Amanda Wilson',
            initials: 'AW',
            department: 'Customer Success',
            avatarColor: '#30D158',
            replyRate: 94,
            boosters: 71,
            debi: 65,
            totalMonths: 7,
            streakMonths: 4
          },
          {
            id: 7,
            name: 'James Lee',
            initials: 'JL',
            department: 'Operations',
            avatarColor: '#5856D6',
            replyRate: 85,
            boosters: 79,
            debi: 61,
            totalMonths: 2,
            streakMonths: 1
          },
          {
            id: 8,
            name: 'Maria Patel',
            initials: 'MP',
            department: 'Human Resources',
            avatarColor: '#32ADE6',
            replyRate: 97,
            boosters: 68,
            debi: 73,
            totalMonths: 10,
            streakMonths: 7
          },
          {
            id: 9,
            name: 'Thomas Kim',
            initials: 'TK',
            department: 'Business Development',
            avatarColor: '#FF3B30',
            replyRate: 91,
            boosters: 74,
            debi: 63,
            totalMonths: 3,
            streakMonths: 1
          },
          {
            id: 10,
            name: 'Rachel Nguyen',
            initials: 'RN',
            department: 'Quality Assurance',
            avatarColor: '#AF52DE',
            replyRate: 89,
            boosters: 72,
            debi: 56,
            totalMonths: 6,
            streakMonths: 3
          }
        ]
      }
    },
    created() {
      console.log('this.$route.params.id===',this.$route.params.id);
        let comp_id = ''
        let month = ''
        // const ciphertext = CryptoJS.AES.encrypt(this.$route.params.id+'||'+'DHAS', 'high-performing-managers').toString();
        // console.log('ciphertext===',ciphertext)

        let bytes = CryptoJS.AES.decrypt(
        //    ciphertext,
        this.$route.params.id,
        "high-performing-managers"
        );
        //console.log('bytes===',bytes)
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        if (originalText) {
        comp_id = originalText.split("||")[0];
        this.com_name=originalText.split("||")[1]
        month = originalText.split("||")[2]?originalText.split("||")[2]:''
        }
        this.$store.dispatch('highPerformingManagers/getData',{com_id:comp_id,month:month,token:this.$route.params.id})
    },
  
    computed: {
        company(){
            return this.$store.getters['highPerformingManagers/company']
        },
        loading(){
            return this.$store.getters['highPerformingManagers/loading']
        },
        replyRate(){
            return this.$store.getters['highPerformingManagers/replyRate']
        },
        debi(){
            return this.$store.getters['highPerformingManagers/debi']
        },
        user(){
            //console.log('user===',this.$store.getters['highPerformingManagers/user'])
            return this.$store.getters['highPerformingManagers/user']
        },
        highPerformingManagers() {
          return this.$store.getters['highPerformingManagers/highPerformingManagers']
        },
        sortedManagers() {
            const managers = [...this.highPerformingManagers];
            const { column, direction } = this.currentSort;
    
            return managers.sort((a, b) => {
            let aValue, bValue;
    
            switch(column) {
                case 'manager':
                aValue = a.name.toLowerCase();
                bValue = b.name.toLowerCase();
                return direction === 'asc' 
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
                case 'reply-rate':
                aValue = a.replyRate;
                bValue = b.replyRate;
                break;
                case 'boosters':
                aValue = a.boosters;
                bValue = b.boosters;
                break;
                case 'debi':
                aValue = a.debi;
                bValue = b.debi;
                break;
                case 'performance-history':
                aValue = a.totalMonths;
                bValue = b.totalMonths;
                break;
                default:
                return 0;
            }
    
            return direction === 'asc' ? aValue - bValue : bValue - aValue;
            });
        },
        autosendgem(){
            return this.$store.getters['highPerformingManagers/autosendgem']
        }
    },
  
    mounted() {
      this.initializeScrollIndicator();
      this.updateHeaderClasses();
    },
  
    methods: {
      handleSort(column) {
        const direction = this.getSortDirection(column);
        this.currentSort = { column, direction };
        this.updateHeaderClasses();
      },
  
      getSortDirection(column) {
        if (this.currentSort.column === column) {
          return this.currentSort.direction === 'asc' ? 'desc' : 'asc';
        }
        return column === 'performance-history' ? 'desc' : 'asc';
      },
  
      updateHeaderClasses() {
        this.$nextTick(() => {
          const headers = this.$el.querySelectorAll('th.sortable');
          headers.forEach(header => {
            header.classList.remove('sort-asc', 'sort-desc');
            if (header.dataset.column === this.currentSort.column) {
              header.classList.add(this.currentSort.direction === 'asc' ? 'sort-asc' : 'sort-desc');
            }
          });
        });
      },
  
      getMetricClass(value) {
        if (value >= 90) return 'excellent';
        if (value >= 70) return 'good';
        return 'moderate';
      },
  
      getDebiClass(value) {
        if (value >= 70) return 'excellent';
        if (value >= 60) return 'good';
        return 'moderate';
      },
  
      getStreakClass(months) {
        if (months >= 7) return 'outstanding';
        if (months >= 5) return 'excellent';
        return 'good';
      },
  
      initializeScrollIndicator() {
        if (window.innerWidth <= 768) {
          const tableContainer = this.$el.querySelector('.managers-table');
          if (tableContainer) {
            tableContainer.addEventListener('scroll', () => {
              this.isTableScrolled = tableContainer.scrollLeft > 10;
            });
          }
        }
      }
    }
  }
  </script>
  
  <style scoped>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: 'Lato', sans-serif;
    background-color: #fff;
    color: #333;
    line-height: 1.6;
  }
  
  .container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 40px 20px;
  }
  
  @media (max-width: 768px) {
    .container {
      padding: 20px 16px;
    }
  }
  
  .header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 32px;
  }
  
  @media (max-width: 768px) {
    .header {
      margin-bottom: 24px;
      gap: 12px;
    }
  }
  
  .logo {
    width: 48px;
    height: 48px;
    background: #7B68EE;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 600;
    font-size: 20px;
  }
  
  .header-text h1 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
  
  .header-text p {
    font-size: 14px;
    color: #666;
    font-weight: 400;
  }
  
  .page-title {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    margin-bottom: 8px;
  }
  
  @media (max-width: 768px) {
    .page-title {
      font-size: 24px;
      line-height: 1.3;
    }
  }
  
  .subtitle {
    font-size: 16px;
    color: #666;
    margin-bottom: 24px;
    line-height: 1.5;
  }
  
  @media (max-width: 768px) {
    .subtitle {
      font-size: 15px;
      margin-bottom: 20px;
    }
  }
  
  .criteria {
    background: #f8f9fa;
    padding: 16px 20px;
    border-radius: 8px;
    margin-bottom: 32px;
    border-left: 4px solid #7B68EE;
    border: 1px solid #e9ecef;
  }
  
  @media (max-width: 768px) {
    .criteria {
      padding: 14px 16px;
      margin-bottom: 24px;
    }
  }
  
  .criteria-text {
    font-size: 14px;
    color: #555;
    font-weight: 400;
  }
  
  .performance-insights {
    background: white;
    padding: 32px;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
    margin-bottom: 32px;
    border: 1px solid #e9ecef;
  }
  
  @media (max-width: 768px) {
    .performance-insights {
      padding: 20px 16px;
      margin-bottom: 24px;
    }
  }
  
  .insights-header {
    text-align: center;
    margin-bottom: 32px;
  }
  
  @media (max-width: 768px) {
    .insights-header {
      margin-bottom: 24px;
    }
  }
  
  .insights-header h2 {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin-bottom: 8px;
  }
  
  @media (max-width: 768px) {
    .insights-header h2 {
      font-size: 20px;
      line-height: 1.3;
    }
  }
  
  .insights-header p {
    font-size: 16px;
    color: #666;
  }
  
  @media (max-width: 768px) {
    .insights-header p {
      font-size: 14px;
    }
  }
  
  .comparison-charts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    margin-bottom: 32px;
  }
  
  @media (max-width: 768px) {
    .comparison-charts {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }
  
  .chart-section {
    background: #f1f3f5;
    padding: 24px;
    border-radius: 8px;
    border: 1px solid #e9ecef;
  }
  
  @media (max-width: 768px) {
    .chart-section {
      padding: 16px;
    }
  }
  
  .chart-header {
    margin-bottom: 20px;
  }
  
  @media (max-width: 768px) {
    .chart-header {
      margin-bottom: 16px;
    }
  }
  
  .chart-header h3 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 12px;
  }
  
  @media (max-width: 768px) {
    .chart-header h3 {
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
  
  .chart-legend {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }
  
  @media (max-width: 768px) {
    .chart-legend {
      flex-direction: column;
      gap: 8px;
    }
  }
  
  .legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #666;
  }
  
  .legend-color {
    width: 16px;
    height: 16px;
    border-radius: 3px;
  }
  
  .legend-color.high-performers {
    background: #7B68EE;
  }
  
  .legend-color.org-average {
    background: #6C757D;
  }
  
  .comparison-bars {
    margin: 20px 0;
  }
  
  .bar-container {
    margin-bottom: 12px;
    position: relative;
  }
  
  .bar {
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 12px;
    color: white;
    font-weight: 600;
    font-size: 14px;
    position: relative;
    min-width: 80px;
  }
  
  .bar.high-performers {
    background: #7B68EE;
  }
  
  .bar.org-average {
    background: #6C757D;
    color: white;
  }
  
  .bar-label {
    position: relative;
    z-index: 1;
  }
  
  .impact-note {
    font-size: 14px;
    color: #28a745;
    font-weight: 600;
    text-align: center;
    margin-top: 16px;
  }
  
  .gem-callout {
    background: #FFDEE7;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    gap: 20px;
  }
  
  @media (max-width: 768px) {
    .gem-callout {
      padding: 16px;
      margin-bottom: 24px;
      gap: 16px;
      flex-direction: column;
      text-align: center;
    }
  }
  
  .gem-icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    flex-shrink: 0;
  }
  
  .gem-content h3 {
    font-size: 16px;
    font-weight: 700;
    color: #D1244D;
    margin: 0 0 4px 0;
    letter-spacing: 0.5px;
  }
  
  @media (max-width: 768px) {
    .gem-content h3 {
      font-size: 15px;
    }
  }
  
  .gem-content p {
    font-size: 14px;
    color: #8B5A6B;
    margin: 0;
    line-height: 1.4;
  }
  
  @media (max-width: 768px) {
    .gem-content p {
      font-size: 13px;
      line-height: 1.5;
    }
  }
  
  .managers-table {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
    border: 1px solid #e9ecef;
    margin-bottom: 40px;
    overflow: hidden;
  }
  
  @media (max-width: 768px) {
    .managers-table {
      margin-bottom: 32px;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
  }
  
  @media (max-width: 768px) {
    .table {
      min-width: 600px;
      font-size: 13px;
    }
  }
  
  .table th {
    background: #f1f3f5;
    padding: 16px 20px;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #e1e5e9;
    cursor: pointer;
    user-select: none;
    position: relative;
    transition: background-color 0.2s ease;
  }
  
  @media (max-width: 768px) {
    .table th {
      padding: 14px 16px;
      font-size: 11px;
      white-space: nowrap;
      min-height: 44px;
      -webkit-tap-highlight-color: rgba(0,0,0,0.1);
    }
  }
  
  .table th:hover {
    background: #e9ecef;
  }
  
  .table th.sortable::after {
    content: ' ↕';
    color: #999;
    font-size: 10px;
    margin-left: 5px;
  }
  
  .table th.sort-asc::after {
    content: ' ↑';
    color: #7B68EE;
    font-weight: bold;
  }
  
  .table th.sort-desc::after {
    content: ' ↓';
    color: #7B68EE;
    font-weight: bold;
  }
  
  .table th:first-child {
    padding-left: 24px;
  }
  
  .table th:last-child {
    padding-right: 24px;
  }
  
  @media (max-width: 768px) {
    .table th:first-child {
      padding-left: 16px;
    }
  
    .table th:last-child {
      padding-right: 16px;
    }
  }
  
  .table td {
    padding: 24px 20px;
    border-bottom: 1px solid #f1f3f4;
    font-size: 14px;
    vertical-align: middle;
  }
  
  @media (max-width: 768px) {
    .table td {
      padding: 16px 16px;
      font-size: 13px;
    }
  }
  
  .table td:first-child {
    padding-left: 24px;
  }
  
  .table td:last-child {
    padding-right: 24px;
  }
  
  @media (max-width: 768px) {
    .table td:first-child {
      padding-left: 16px;
    }
  
    .table td:last-child {
      padding-right: 16px;
    }
  }
  
  .table tbody tr:hover {
    background: #f1f3f5;
    transition: background-color 0.2s ease;
  }
  
  .table tbody tr:last-child td {
    border-bottom: none;
  }
  
  .manager-cell {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
  @media (max-width: 768px) {
    .manager-cell {
      gap: 12px;
    }
  }
  
  .manager-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 600;
    font-size: 14px;
    flex-shrink: 0;
  }
  
  @media (max-width: 768px) {
    .manager-avatar {
      width: 36px;
      height: 36px;
      font-size: 13px;
    }
  }
  
  .manager-info h3 {
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }
  
  .manager-info p {
    font-size: 13px;
    color: #666;
  }
  
  @media (max-width: 768px) {
    .manager-info h3 {
      font-size: 13px;
      line-height: 1.3;
    }
  
    .manager-info p {
      font-size: 12px;
    }
  }
  
  .metric-badge {
    padding: 6px 12px;
    border-radius: 6px;
    font-weight: 600;
    font-size: 13px;
    display: inline-block;
    min-width: 50px;
    text-align: center;
  }
  
  @media (max-width: 768px) {
    .metric-badge {
      padding: 5px 10px;
      font-size: 12px;
      min-width: 45px;
    }
  }
  
  .metric-badge.excellent {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  }
  
  .metric-badge.good {
    background-color: #fff3cd;
    color: #856404;
    border: 1px solid #ffeaa7;
  }
  
  .metric-badge.moderate {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  }
  
  .performance-history {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }
  
  @media (max-width: 768px) {
    .performance-history {
      gap: 4px;
    }
  }
  
  .total-months {
    font-size: 16px;
    font-weight: 700;
    color: #333;
  }
  
  @media (max-width: 768px) {
    .total-months {
      font-size: 14px;
    }
  }
  
  .current-streak {
    font-size: 11px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 8px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }
  
  @media (max-width: 768px) {
    .current-streak {
      font-size: 10px;
      padding: 2px 5px;
    }
  }
  
  .current-streak.good {
    background: #FFF3CD;
    color: #856404;
    border: 1px solid #FFEAA7;
  }
  
  .current-streak.excellent {
    background: #D4EDDA;
    color: #155724;
    border: 1px solid #C3E6CB;
  }
  
  .current-streak.outstanding {
    background: #CCE5FF;
    color: #004085;
    border: 1px solid #B3D7FF;
  }
  
  .text-center {
    text-align: center;
  }
  
  /* Mobile scroll indicator for table */
  @media (max-width: 768px) {
    .managers-table::after {
      content: "← Swipe to see all columns →";
      display: block;
      text-align: center;
      font-size: 12px;
      color: #666;
      padding: 8px;
      background: #f8f9fa;
      border-top: 1px solid #e9ecef;
      font-style: italic;
    }
    
    .managers-table.scrolled::after {
      content: "← Swipe to see more →";
    }
  }
  </style>